

import { CallReceivedOutlined, Contacts, LibraryAddCheckOutlined, WarehouseOutlined } from '@mui/icons-material';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import InputIcon from '@mui/icons-material/Input';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { Box, ButtonBase } from '@mui/material';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
export const relationReturnsDesignConfig = {
    returnportalsettings: {
        title: 'returnportalsettings',
        icon: <AccountTreeOutlinedIcon />,
    },
    return_costs: {
        title: 'return_costs',
        icon: <ReceiptLongIcon />,
    },
    return_reasons: {
        title: 'return_reasons',
        icon: <AccountTreeOutlinedIcon />,
    },
    vormgeving: {
        title: 'vormgeving',
        icon: <AccountTreeOutlinedIcon />,
    },
}
